<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  @if (charts.length > 0) {
    <div class="ai-suggestion-charts-grid">
      @for (chart of charts; track $index) {
        <div
          #chartWrapper
          class="ai-suggestion-chart-card"
          [class.half-width]="chart.width === '50%'"
          [class.full-width]="chart.width !== '50%'">
          <highcharts-chart
            [options]="chart.options"
            [style.width]="'100%'"
            [style.height]="chart.height || '360px'"
            style="display: block;">
          </highcharts-chart>
        </div>
      }
    </div>
  }
  <div [innerHTML]="message"></div>
</div>

<div mat-dialog-actions class="ai-dialog-actions">
  <span class="ai-disclaimer">
    <mat-icon class="ai-disclaimer-icon">auto_awesome</mat-icon>
    AI-generated &ndash; verify before acting
  </span>
  <span class="ai-dialog-actions-spacer"></span>
  <button type="button" mat-stroked-button (click)="downloadAsPDF()" [disabled]="downloading">
    <mat-icon>picture_as_pdf</mat-icon>
    {{ downloading ? 'Downloading...' : 'Download PDF' }}
  </button>
  @if (onActions) {
    <button type="button" mat-stroked-button (click)="actions()" [disabled]="actionsStatus !== 'ready'"
      [matTooltip]="actionsStatus === 'error' ? 'AI suggested actions are unavailable. Please try again later.' : ''">
      @switch (actionsStatus) {
        @case ('loading') { Loading actions... }
        @case ('error') { Actions unavailable }
        @default { Actions }
      }
    </button>
  }
  <button type="button" mat-raised-button color="primary" class="ai-close-button" (click)="onClose()">Close</button>
</div>
